import * as React from "react";
import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import StyledGrid from "../../../shared/components/StyledGrid";

import useFetchWithMsal from "../../../utils/useFetchWithMsal";
import { useSelector } from "react-redux";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, InputLabel, MenuItem, Select, Snackbar } from "@mui/material";
import { LoadingPanel } from "../../../shared/components/LoadingPanel";
import { useAddLicenseMutation, useAddMemberHistoryNoteMutation, useDeleteLicenseMutation, useEditLicenseMutation, useGetLicensesQuery, useGetPaginateHistoryMutation } from "../../../services/InsuranceService";
import { AddNotePopup } from "../../memberForm/popups/AddNotePopup";
import SelectField from "../../../shared/components/SelectField";
import { LicensePopup } from "./popups/LicensePopup";
import moment from "moment";
import { Delete, Edit } from "@mui/icons-material";
import { MultiFieldContainer } from "../communicationTab/CommunicationTab.styled";

export const LicensesTab = (props) => {

  const { naicCode, naicMemberRoleCheck, memberKey, licensesTypes, licensesType } = props;

  const getLicenseIdByName = (name) => licensesTypes?.find(item => item.name === name)?.id || null;

  const { skip } = useFetchWithMsal();

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 50,
  });
  const [totalCount, setTotalCount] = useState(0);

  const [sortingModel, setSortingModel] = useState();

  const [isShowLicensePopup, setIsShowLicensePopup] = useState(false);

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteRowId, setDeleteRowId] = useState(null);

  const [selectedValue, setSelectedValue] = useState('');
  const [rowData, setRowData] = useState({});

  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const { data: licenses, isLoading, refetch } = useGetLicensesQuery(
    memberKey ? {
      id: memberKey,
      licenseTypeId: getLicenseIdByName(licensesType),
      refreshKey: isShowLicensePopup,
    } : skip, 
    {
      skip: skip || !memberKey,
      refetchOnMountOrArgChange: true,
    }
  );

  const [addLicense, {}] = useAddLicenseMutation("", { skip });
  const [editLicense, {}] = useEditLicenseMutation("", { skip });

  const handleAddLicense = async (licenseData) => {
    try {
      const response = await addLicense(licenseData).unwrap(); // Разворачиваем результат запроса
      if (response?.Message) {
        setSnackbarMessage(response?.Message);
        setSnackbarOpen(true);
      }
    } catch (error) {
      setSnackbarMessage(error?.data?.Message);
      setSnackbarOpen(true);
    }
  };
  
  const handleEditLicense = async (licenseData) => {
    try {
      const response = await editLicense(licenseData).unwrap(); 
      if (response.Message) {
        setSnackbarMessage(response.Message);
        setSnackbarOpen(true);
      }
    } catch (error) {
      setSnackbarMessage(error?.data?.Message);
      setSnackbarOpen(true);
    }
  };

  const [deleteLicense, { isLoading: isLoadingDeleteLicense, isSuccess }] = useDeleteLicenseMutation("");

  useEffect(() => {
    if (licenses && (isShowLicensePopup === false || isLoadingDeleteLicense === false)) {
      setTimeout(() => {
        refetch();
      }, 1000);
    }
  }, [isShowLicensePopup, isLoadingDeleteLicense])

  const onRowClick = (e) => {
    setIsShowLicensePopup(!isShowLicensePopup)
    setRowData(e.row)
  }

  const licensesColumns = [
    { field: 'licenseType', headerName: 'License type', width: 100, editable: true },
    {
      field: 'startDate',
      headerName: 'Start date',
      width: 150,
      editable: true,
      valueGetter: (value) => 
        value ? moment.utc(value).local().format("MM/DD/YYYY") : "N/A",
    },
    {
      field: 'expirationDate',
      headerName: 'Expiration date',
      width: 150,
      editable: true,
      valueGetter: (value) => 
        value ? moment.utc(value).local().format("MM/DD/YYYY") : "N/A",
    },
    { field: 'user', headerName: 'User', width: 50, editable: true, flex: 1 },
    {
      field: 'modifyDate',
      headerName: 'Modify date',
      width: 150,
      editable: true,
      valueGetter: (value) => 
        moment.utc(value).local().format("MM/DD/YYYY"),
    },
    {
      field: "edit",
      headerName: "",
      width: 30,
      editable: true,
      renderCell: (params) => (
        <MultiFieldContainer>
          <Edit
            style={{ cursor: "pointer", color: "#003366" }}
            onClick={() => onRowClick(params)}
          />
        </MultiFieldContainer>
      ),
    },
    {
      field: "delete",
      headerName: "",
      width: 30,
      editable: true,
      renderCell: (params) => (
        <MultiFieldContainer>
          <Delete
            style={{ cursor: "pointer", color: "#990000" }}
            onClick={() => handleDeleteClick(params.row.id)}
          />
        </MultiFieldContainer>
      ),
    }

  ];

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };


  // const [getPaginateHistory, { data, isLoading }] = useGetPaginateHistoryMutation("", { skip });

  const { memberName } = useSelector(
    (state) => state.filter
  );

  // useEffect(() => {
  //   fetchData()
  // }, [
  //   paginationModel.page,
  //   paginationModel.pageSize,
  //   sortingModel?.field,
  //   sortingModel?.sort,
  //   naicCode
  // ]);

  useEffect(() => {
    if (!isLoading) {
      if (licenses?.totalCount !== totalCount) {
        setTotalCount(licenses?.totalCount);
      }
    }
  }, [isLoading, licenses?.totalCount]);

  const handlePaginationModelChange = (newPaginationModel) => {
    setPaginationModel(newPaginationModel);
  };

  // const handleAddMemberHistoryNote = (body) => {
  //   addMemberHistoryNote(body)
  //   setTimeout(() => {
  //     fetchData();
  //   }, 500);
  // }

  const onPopupClose = () => {
    setIsShowLicensePopup(false);
    setRowData({})
  };

  const handleDeleteDialogOpen = (rowId) => {
    setDeleteRowId(rowId);
    setDeleteDialogOpen(true);
  };

  const handleDeleteDialogClose = () => {
    setDeleteDialogOpen(false);
  };

  const handleDeleteClick = (rowId) => {
    handleDeleteDialogOpen(rowId);
  };

  return (
    <Box sx={{ height: "100%", width: "100%", margin: "15px auto 0 auto" }}>
      {isLoading && <LoadingPanel />}
      <Box sx={{ height: "100%", width: "100%", display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          variant="outlined"
          onClick={() => setIsShowLicensePopup(!isShowLicensePopup)}
          sx={{ height: "100%", width: "auto", margin: "0 25px 15px 0" }}
        >
          Add new
        </Button>
      </Box>
      <StyledGrid
        data={licenses?.items}
        width="100%"
        columns={licensesColumns}
        rowCount={totalCount}
        onSortingModelChange={(model) => setSortingModel(model[0])}
        paginationModel={paginationModel}
        setPaginationModel={handlePaginationModelChange}
      // onRowClick={onRowClick}
      // withMenu
      />
      <LicensePopup
        open={isShowLicensePopup}
        onClose={onPopupClose}
        data={rowData}
        licensesTypes={licensesTypes}
        memberKey={memberKey}
        addLicense={handleAddLicense}
        editLicense={handleEditLicense}
      />
      <Dialog
        open={deleteDialogOpen}
        onClose={handleDeleteDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Are you sure?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Do you really want to delete this license?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteDialogClose} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              deleteLicense(deleteRowId);
              handleDeleteDialogClose();
            }}
            color="primary"
            autoFocus
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={() => setSnackbarOpen(false)} severity="error" sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};
